// Per-instance choice of where a slide-deck content read is served from:
//   'v1' — the getSlideDeckForAssignment cloud function (Firestore)
//   'v2' — the Adonis /api/v1/slide_decks/:id endpoint (Postgres)
//
// v2 is opt-in per read: the default is v1, and a caller reaches v2 only by
// passing this override (set from ?source=v2, e.g. the CX-only deck-source
// toggle). Undefined = the v1 cloud function.
export type SlideDeckReadSource = 'v1' | 'v2'

// Decide whether a slide-deck read should use the v2 (Adonis) path. Only a
// 'v2' override opts in; everything else stays on v1. The v2 branch still needs
// an injected api client — a forced 'v2' without one is honored by the caller's
// own `&& repository.api` guard, which falls back to v1 rather than crashing.
export function shouldUseV2SlideDeckRead(
  override?: SlideDeckReadSource
): boolean {
  return override === 'v2'
}

// Narrow an untrusted value (e.g. a URL query param) to a SlideDeckReadSource,
// or undefined when it isn't one. Use at the mount point to turn `?source=…`
// into a cubit override.
export function parseSlideDeckReadSource(
  value: unknown
): SlideDeckReadSource | undefined {
  return value === 'v1' || value === 'v2' ? value : undefined
}
